<template>
  <div>
    <form ref="form" :data-url="siteLogUrl" class="mb-0" :class="{'loading-opacity': preloader}">
      <div class="form-group row align-items-center">
        <div>
          <app-button :isDisabled="false" type="submit" :label="getButtonText() +' '+ $t('now')" class-name="btn-info rounded-pill mr-2"
                      v-on:submit="submit(eventType)" />

          <app-button :isDisabled="false" type="submit" :label="$t('add-another-time')" class="btn-dark rounded-pill mr-2"
                      @submit="showDateTime()"/>
        </div>
      </div>
      <div v-if="showCalendar" class="form-group row align-items-center">
        <div class="col-md-12 mb-sm-0">
          <label for="event_recorded_at">
            {{ $t('event_recorded_at') }}
          </label>
        </div>
        <div class="col-md-4">
          <app-input
            :required="true"
            type="date"
            v-model="inputs.event_recorded_at"
            :placeholder="$t('select_valid_date')"/>
        </div>
        <div class="col-md-4">
          <app-input
            :required="true"
            type="time"
            v-model="inputs.time_picker"
            :placeholder="$t('select_valid_time')"/>
        </div>
        
        <div class="action-buttons">
          <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit(eventType)">
            {{ getButtonText() }}
          </button>
        </div>

      </div>

    </form>

  </div>
</template>


<script>

import {TableHelpers} from "../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import {
  SITE_LOGS_DATA
} from "../../../../../../Config/ApiUrl.js";
import {axiosGet} from "../../../../../../Helpers/AxiosHelper.js";
import {FormMixin} from "@/core/mixins/form/FormMixin";

import GlobalHelperMixin from "@/app/Mixins/global/GlobalHelperMixin";
import AppLibrary from "@/app/Helpers/AppLibrary";

export default {
  name: 'CheckinForm',
  extends: CoreLibrary,
  mixins: [GlobalHelperMixin, FormMixin, AppLibrary, TableHelpers],

  props: {
    siteCheckingType: String,
    buttonText: String,
    eventType: String,
    siteLogUrl: String,

  },
  data() {
    return {

      showCalendar: false,
      bgStyle: true,
      displayForm: false,
      preloader: false,
      inputs: {},
    };
  },
  created() {

  },
  computed: {
    siteData(){
      this.$hub.$on('siteData', (data) => {
        this.siteData = data;
      })
    },

    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    themeMode() {
      return this.$store.state.theme;
    },
  },
  methods: {
    getButtonText(){
      return this.$t(this.buttonText)
    },
    showDateTime() {
      this.showCalendar = true
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
    },

    beforeSubmit() {
      this.preloader = true;
    },
    submit(event_type) {

      this.inputs.event_type = event_type;
      this.inputs.severity = 1;
      this.inputs.event_status = 2;
      this.save(this.inputs);

    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
    },
    getListValues() {

      axiosGet(SITE_LOGS_DATA).then((response) => {
        this.idsToValues = response.data.ids_to_values;
        this.eventStatus = response.data.event_status;
        this.severity = response.data.severity;
        this.eventTypes = response.data.event_types;
      });
    },

    searchAndSelectFilterOptions() {
      // axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.siteId).then((response) => {
      //
      //
      //   name.option = response.data.map((name) => {
      //     return {
      //       id: name.id,
      //       value: name.value,
      //     };
      //   });
      // });
    },
  },
  mounted() {

    this.getListValues();
    // this.options.url = this.$attrs['props'].url != null ? this.$attrs['props'].url + '/' + this.siteId : SITE_LOGS_LIST + '/' + this.siteId;
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");

  },
};
</script>
